import { c as _c } from "react/compiler-runtime";
import React, { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { CardListItem, CardListItemProps } from 'record-it-components/cardList/CardListItem/CardListItem';
import { CardListItemIconButton } from 'record-it-components/cardList/CardListItemIconButton/CardListItemIconButton';
import { CardListItemIconLink } from 'record-it-components/cardList/CardListItemIconLink/CardListItemIconLink';
import { CardListItemTitleWithSubtitle } from 'record-it-components/cardList/CardListItemTitleWithSubtitle/CardListItemTitleWithSubtitle';
import { prepareProps } from 'record-it-components/utils/propUtils';
import { PropsWithoutChildren } from 'record-it-components/utils/utilityTypes';
import { DateUtils } from 'record-it-utils/utils/DateUtils/DateUtils';
import { WorkTimeEntry } from '../../../classes/entities/WorkTimeEntry/workTimeEntryTypes';
import { iconConfigurations } from '../../../classes/icon/iconConfigurations';
import { RoutePaths } from '../../../classes/RoutePaths/RoutePaths';
import { useWorkTimeEntryDeleteHandler } from '../../../hooks/entity/deleteHandler/useWorkTimeEntryDeleteHandler';
import { useTimeTrackingActivityPathName } from '../../../hooks/entity/timeTrackingActivity/useTimeTrackingActivityPathName';
export type WorkTimeEntryListItemProps = PropsWithoutChildren<CardListItemProps> & {
  workTimeEntry: WorkTimeEntry;
};
export const WorkTimeEntryListItem: FunctionComponent<WorkTimeEntryListItemProps> = React.memo(props => {
  const $ = _c(21);
  let t0;
  if ($[0] !== props) {
    t0 = prepareProps({
      props,
      ignoreChildren: true
    });
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let remainingProps;
  let workTimeEntry;
  if ($[2] !== t0) {
    ({
      workTimeEntry,
      ...remainingProps
    } = t0);
    $[2] = t0;
    $[3] = remainingProps;
    $[4] = workTimeEntry;
  } else {
    remainingProps = $[3];
    workTimeEntry = $[4];
  }
  const {
    t
  } = useTranslation();
  const handleDeleteClick = useWorkTimeEntryDeleteHandler(workTimeEntry);
  const activityPathName = useTimeTrackingActivityPathName(workTimeEntry.timeTrackingActivityId);
  let t1;
  if ($[5] !== activityPathName || $[6] !== t || $[7] !== workTimeEntry.endDate || $[8] !== workTimeEntry.startDate) {
    t1 = <CardListItemTitleWithSubtitle data-testid="WorkTimeEntryListItem.TitleWithSubtitle">{() => ({
        title: activityPathName ?? t("components.workTime.WorkTimeEntryListItem.noActivity"),
        subtitle: DateUtils.withCurrentTimezone().formatDateRange(workTimeEntry.startDate, workTimeEntry.endDate)
      })}</CardListItemTitleWithSubtitle>;
    $[5] = activityPathName;
    $[6] = t;
    $[7] = workTimeEntry.endDate;
    $[8] = workTimeEntry.startDate;
    $[9] = t1;
  } else {
    t1 = $[9];
  }
  let t2;
  if ($[10] !== handleDeleteClick) {
    t2 = <CardListItemIconButton {...iconConfigurations.prefixed.listItem.deleteIcon} onClick={handleDeleteClick} data-testid="WorkTimeEntryListItem.DeleteButton" />;
    $[10] = handleDeleteClick;
    $[11] = t2;
  } else {
    t2 = $[11];
  }
  let t3;
  if ($[12] !== workTimeEntry.id) {
    t3 = RoutePaths.editWorkTimeEntry(workTimeEntry.id);
    $[12] = workTimeEntry.id;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  let t4;
  if ($[14] !== t3) {
    t4 = <CardListItemIconLink to={t3} {...iconConfigurations.prefixed.listItem.editInExtraPageIcon} />;
    $[14] = t3;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  let t5;
  if ($[16] !== remainingProps || $[17] !== t1 || $[18] !== t2 || $[19] !== t4) {
    t5 = <CardListItem {...remainingProps}>{t1}{t2}{t4}</CardListItem>;
    $[16] = remainingProps;
    $[17] = t1;
    $[18] = t2;
    $[19] = t4;
    $[20] = t5;
  } else {
    t5 = $[20];
  }
  return t5;
});